import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";

export default function ModalHeader({ isModal, onClose }) {
  return (
    <div
      style={{
        background: `linear-gradient(
            91.64deg,
            ${HNSColors.primary[300]} -2.29%,
            ${HNSColors.primary[400]} 24.1%,
            ${HNSColors.primary[500]} 46.74%,
            ${HNSColors.tertiary[500]} 89.2%,
            ${HNSColors.tertiary[700]} 102.56%
          )`,
        boxShadow: `0px 3px 45px 0px ${HNSColors.tertiary[900]}`,
      }}
      className="relative my-3 flex w-full items-center justify-between gap-2 rounded-[12px] p-4 text-white"
    >
      <div className="flex items-center gap-2">
        <Svg
          name={SvgEnum.HisHandshakeHeart}
          color={HNSColors.neutrals[900]}
          sx={{ width: "1.5rem" }}
        />
        <h2 className="text-2xl font-semibold">{"Add Provider"}</h2>
      </div>

      <div>
        {isModal && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            style={{
              color: HNSColors.neutrals[900],
            }}
          >
            <Close />
          </IconButton>
        )}
      </div>
    </div>
  );
}
